import { render, staticRenderFns } from "./product-brand.vue?vue&type=template&id=0f13e55e&scoped=true&"
import script from "./product-brand.vue?vue&type=script&lang=js&"
export * from "./product-brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f13e55e",
  null
  
)

export default component.exports